import { Box, Divider, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import { useLocation, useNavigate } from 'react-router-dom';
import KenButton from '../../../GlobalComponents/KenButton';
import KenInput from '../../../GlobalComponents/KenInput';
import KenLoader from '../../../GlobalComponents/KenLoader';
import  { useContext, useEffect } from 'react';
import { SubTitle } from '../../../GlobalComponents/KenTitle';
import routes from '../../../Utils/routes';
import { getOtp, loginSSO, registerDevice } from '../../../Utils/apiService';
import { useSnackbar } from 'notistack';
import KenSelect from '../../../GlobalComponents/KenSelect';
import { SignUpFormData } from '../../../interfaces/Auth';
import { AuthContext } from '../../../Helpers/Contexts/authContext';
import KenPhoneInput from '../../../GlobalComponents/KenPhoneInput';
import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js';
import { auth, provider } from '../../../firebase/firebase';
import { useStyles } from '../styles';
import { getToken,onMessage } from "firebase/messaging";
import { signupForm } from '../../../Utils/FormJsons/signupForm';
import KenTextLabel from '../../../GlobalComponents/KenTextLabel';
import Image from '../../../Assets/assetHelper';
import { GoogleLoginButton } from 'react-social-login-buttons';
import { signInWithPopup } from 'firebase/auth';
import { fontWeight } from '@mui/system';
interface LoginSSOResponse {
  data?: {
    firstName: string;
    Ken_Alumni_CRM__r: any;
    success: boolean;
    Id: string;
    Name: string;
    Photo__c: string;
    Year_of_Graduation__c: string;
    accessToken?: { token: string };
    refreshToken?: { token: string };
    turbosendToken?: {
      idToken: string;
      refreshToken: string;
    };
  };
  errorMessage?: string;
}

const EmailSignup: React.FunctionComponent = () => {
  const classes = useStyles();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { dispatch } = useContext(AuthContext);
  const { enqueueSnackbar } = useSnackbar();
    const [fcmtoken, setFcmToken] = useState("");
  const { handleSubmit, control, clearErrors } = useForm<SignUpFormData>({
    mode: 'onChange',
    defaultValues: {
      ...state,
    },
  });

  const [loader, setLoader] = useState<boolean>(false);
  const [isValidMobile, setIsValidMobile] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const onSubmit: SubmitHandler<SignUpFormData> = async (data) => {
    if (isValidMobile) {
      enqueueSnackbar({ message: 'Please resolve all the error', variant: 'error', autoHideDuration: 3000 }); // Increased duration
      return;
    }
    setLoader(true);
    getOtp(data.email, false)
      .then((res: any) => {
        if (res?.success) {
          navigate(routes.otpverification, { state: { email: data.email, data: data } });
        } else {
          console.log(res?.response?.data?.errorMessage?.errorMessage, 'abcdef'); // Debugging error message
          enqueueSnackbar({
            message: res?.response?.data?.errorMessage?.errorMessage || 'An error occurred', // Default error message if none is available
            variant: 'error',
            autoHideDuration: 3000, // Increased duration
          });
        }
        setLoader(false);
      })
      .catch((err) => {
        enqueueSnackbar({ message: 'Something Went Wrong', variant: 'error', autoHideDuration: 3000 }); // Increased duration
        console.error(err);
        setLoader(false);
      });
  };
    useEffect(() => {
    const registerServiceWorker = async () => {
      if ("serviceWorker" in navigator) {
        try {
          const registration = await navigator.serviceWorker.register("/firebase-messaging-sw.js");
          console.log("Service Worker registered:", registration);

          const fcmToken = await getToken(messaging, {
            vapidKey: "BLottGqnSSyOuoSisCqGW12IarH10LQUfB_PdbaglRv7ThalvKZNliXFpqfP_RUm0A8WTb_ouyQtp7wToKiy2Ps",
            serviceWorkerRegistration: registration, // Important for service worker scope
          });

          if (fcmToken) {
            setFcmToken(fcmToken);
            console.log("FCM Token:", fcmToken);
          } else {
            console.log("No FCM token available.");
          }
        } catch (error) {
          console.error("Service Worker registration failed:", error);
        }
      }
    };

    registerServiceWorker();
  }, []);
    const registeFCMToken = (userId: string, token: string) => {
      setLoading(true);
      registerDevice({
        userId,
        token
      })
        .then((res: any) => {
          if (res) {
          }
   
        })
        .catch((err) => {
          console.log(err, 'error');
        });
    };
const handleGoogleSignIn = async () => {
  setLoading(true);

  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    if (!user || !user.email) {
      enqueueSnackbar({
        message: "Google authentication failed (no email). Try again.",
        variant: "error",
      });
      return;
    }

    const email = user.email;

    const response = (await loginSSO(email)) as LoginSSOResponse;
    console.log("loginSSO response:", response);

    if (!response?.data?.success) {
      enqueueSnackbar({
        message: response?.errorMessage || "Login failed",
        variant: "error",
      });
      return;
    }

    const resData = response.data;

    if (!resData.accessToken?.token || !resData.refreshToken?.token) {
      enqueueSnackbar({
        message: "Login response missing tokens. Contact support.",
        variant: "error",
      });
      return;
    }

    const isActive = resData?.Ken_Alumni_CRM__r?.records?.[0]?.Is_Active__c;

    if (!isActive) {
      enqueueSnackbar({
        message: "Your account is pending approval. Please wait for admin approval before logging in.",
        variant: "error",
      });
      return;
    }

    // ✅ Store user in auth state
    dispatch({
      type: "LOGIN",
      payload: {
        user: {
          applicantEmail: email,
          applicantId: resData.Id,
          applicantName: resData.firstName,
          applicationProfile: resData.Photo__c,
          graduationYear: `${resData.Year_of_Graduation__c}`,
          accessToken: {
            token: resData.accessToken.token,
          },
          refreshToken: {
            token: resData.refreshToken.token,
          },
          turbosendToken: {
            idToken: resData.turbosendToken?.idToken || "",
            refreshToken: resData.turbosendToken?.refreshToken || "",
          },
          applicantFirstName: '',
          applicantLastName: '',
          status: {
            isProfileVerified: false,
            isSignupCompleted: false,
            isActive: isActive,
          },
        },
      },
    });

    // ✅ Register FCM token if available
    if (resData.Id && fcmtoken) {
      await registeFCMToken(resData.Id, fcmtoken);
    }

    // ✅ Redirect to signup page
    navigate('/signup');

  } catch (error: any) {
    console.error("Google Sign-In Error:", error);

    if (error?.code === 'auth/popup-closed-by-user') {
      enqueueSnackbar({
        message: "Google sign‑in was cancelled by the user.",
        variant: "warning",
      });
    } else if (error?.code === 'auth/cancelled-popup-request') {
      enqueueSnackbar({
        message: "Google sign‑in cancelled due to conflicting popup. Try again.",
        variant: "warning",
      });
    } else {
      enqueueSnackbar({
        message: "User does not exist.",
        variant: "error",
      });
    }
  } finally {
    setLoading(false);
  }
};

  const validatePhoneNumber = (inputPhoneNumber: string, countryCode: CountryCode) => {
    clearErrors('phone');
    const isValid = isValidPhoneNumber(inputPhoneNumber, `${countryCode}`.toUpperCase() as CountryCode);
    setIsValidMobile(!isValid); // Invert logic: true means invalid, false means valid
  };

  return (
    <>
      {loader && <KenLoader />}
 <form onSubmit={handleSubmit(onSubmit)} className={classes.formLayout} style={{marginTop: '40%'}}>
  {loader && <KenLoader />}

  <Typography className={classes.title} fontSize="20px !important">
    Register
  </Typography>
  <Typography>Create your alumni account to get started</Typography>

  <Box width="60%" display="flex" flexDirection="column" mt="30px">
    {/* Email Input */}
    <Box mb={1.5} width="100%">
      <Controller
        name="email"
        control={control}
        rules={{
          required: 'Please enter your email address',
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: 'Please enter a valid email address',
          },
        }}
        render={({ field, fieldState: { error } }) => (
          <KenInput
            label="Register with your Email Address"
            placeholder="Enter your email"
            labelClassName={classes.label}
            error={error?.message}
            InputProps={{ className: classes.inputStyles }}
            {...field}
          />
        )}
      />
    </Box>
  </Box>

 

<KenButton
  buttonClass={classes.verify1}
  disabled={loader}
  type="submit"
  sx={{ width: '60%' }} // If using MUI v5 and KenButton supports `sx`
>
  Register
</KenButton>
 <Divider sx={{ my: 3 }} />
          <Typography>(or continue with)</Typography>

       <Box display="flex" justifyContent="center" width="60%" mt={2}>
<GoogleLoginButton
  text="Google"
  onClick={handleGoogleSignIn}
  iconSize="24px"
  style={{
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    borderRadius: '8px',
    fontSize: '14px', // Adjust for readability
    paddingTop: '5px',
    paddingBottom: '5px',
    fontWeight: 500,
    gap: '8px',
    width: '100%',
    lineHeight: '10px', // Helps with vertical centering
    boxSizing: 'border-box',
  }}
/>


</Box>


  <p className={classes.accountLink}>
    Have an account already?{' '}
    <Box
      component="span"
      className="anchorLinks"
      onClick={() => navigate(routes.login)}
    >
      Login
    </Box>
  </p>
</form>

    </>
  );
};

export default EmailSignup;

